import destroy from './destroy';
import store from './store';
import show from './show';
import update from './update';
import all from './all';
import warehouseShippingProvider from './warehouseShippingProvider';

export default {
  destroy,
  store,
  show,
  update,
  all,
  warehouseShippingProvider,
};



// WEBPACK FOOTER //
// ./src/app/services/shippingProvider/index.js